import { render, staticRenderFns } from "./LayoutIndexLeftJx.vue?vue&type=template&id=2addbbca&scoped=true&"
import script from "./LayoutIndexLeftJx.vue?vue&type=script&lang=js&"
export * from "./LayoutIndexLeftJx.vue?vue&type=script&lang=js&"
import style0 from "./LayoutIndexLeftJx.vue?vue&type=style&index=0&id=2addbbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addbbca",
  null
  
)

export default component.exports